<template lang="pug">
  div
    div.field
      div.label.text-caption  Vat id
      span No own VAT ID

    div.field(v-if="details.proofCertificateId")
      div.label.text-caption Cancellation Certificate
      VatCertificate(:certificate-id="details.proofCertificateId")

    div.field
      div.label.text-caption Has Voec Details
      span {{details.haveOwnVoecId ? 'Yes' : 'No'}}
</template>

<script lang="ts">
import Vue from 'vue';
import { VatDetailsT } from 'Api/models/Vat';
import VatCertificate from 'Merchant/common/components/vat-section/vat-certificate.vue';

export default Vue.extend({
  components: { VatCertificate },
  props: {
    details: {
      type: Object as () => VatDetailsT,
      required: true,
    },
  },
});
</script>
